import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import LegalLayout, { LegalSection } from "./LegalLayout";

export default function TermosDeUso() {
  const { t } = useTranslation();

  const sections: LegalSection[] = [
    {
      id: "aceitacao",
      title: t("termos.s1_title", "1. Aceitação dos Termos"),
      content: <p>{t("termos.s1_p", "Ao acessar e utilizar este site, você aceita e concorda em estar vinculado aos termos e disposições deste acordo. Além disso, ao usar os serviços particulares deste site, você estará sujeito a quaisquer regras ou diretrizes publicadas aplicáveis a tais serviços.")}</p>,
    },
    {
      id: "servicos",
      title: t("termos.s2_title", "2. Descrição dos Serviços"),
      content: <p>{t("termos.s2_p", "A Calriz fornece serviços de consultoria em TI, desenvolvimento de software e soluções em nuvem Google Cloud. Reservamo-nos o direito de modificar, suspender ou descontinuar qualquer aspecto do serviço a qualquer momento.")}</p>,
    },
    {
      id: "propriedade-intelectual",
      title: t("termos.s3_title", "3. Propriedade Intelectual"),
      content: <p>{t("termos.s3_p", "Todo o conteúdo incluído neste site, como texto, gráficos, logotipos, ícones, imagens, clipes de áudio e software, é propriedade da Calriz ou de seus fornecedores de conteúdo e protegido pelas leis de direitos autorais do Brasil e internacionais.")}</p>,
    },
    {
      id: "uso-permitido",
      title: t("termos.s4_title", "4. Uso Permitido"),
      content: (
        <>
          <p>{t("termos.s4_p", "Você concorda em não:")}</p>
          <ul>
            <li>{t("termos.s4_l1", "Usar o site para qualquer finalidade ilegal ou não autorizada;")}</li>
            <li>{t("termos.s4_l2", "Tentar interferir ou comprometer a integridade ou segurança do sistema;")}</li>
            <li>{t("termos.s4_l3", "Coletar informações de outros usuários sem consentimento;")}</li>
            <li>{t("termos.s4_l4", "Reproduzir, duplicar, copiar, vender, revender ou explorar qualquer parte do Serviço sem permissão expressa por escrito.")}</li>
          </ul>
        </>
      ),
    },
    {
      id: "responsabilidade",
      title: t("termos.s5_title", "5. Limitação de Responsabilidade"),
      content: <p>{t("termos.s5_p", "Em nenhuma circunstância a Calriz será responsável por quaisquer danos diretos, indiretos, incidentais, especiais, consequenciais ou exemplares resultantes do uso ou da incapacidade de usar o serviço ou para custo de aquisição de serviços substitutos.")}</p>,
    },
    {
      id: "modificacoes",
      title: t("termos.s6_title", "6. Modificações dos Termos"),
      content: <p>{t("termos.s6_p", "A Calriz reserva-se o direito de alterar estes termos a qualquer momento. Recomendamos que você revise esta página periodicamente para quaisquer alterações. O uso continuado do site após a publicação de alterações constituirá sua aceitação de tais alterações.")}</p>,
    },
    {
      id: "lei-aplicavel",
      title: t("termos.s7_title", "7. Lei Aplicável"),
      content: <p>{t("termos.s7_p", "Estes termos serão regidos e interpretados de acordo com as leis do Brasil, sem considerar seus conflitos de disposições legais. Você concorda expressamente que a jurisdição exclusiva para qualquer reivindicação ou ação decorrente ou relacionada a estes Termos de Uso ou uso deste site será arquivada apenas nos tribunais estaduais ou federais localizados em São Paulo, SP.")}</p>,
    },
    {
      id: "contato",
      title: t("termos.s8_title", "8. Contato"),
      content: (
        <p>
          {t("termos.s8_p", "Se você tiver alguma dúvida sobre estes Termos de Uso, entre em contato conosco através do email:")}{" "}
          <strong>contato@calriz.com.br</strong>
        </p>
      ),
    },
  ];

  return (
    <LegalLayout
      seo={{ page: "termos", path: "/termos-de-uso" }}
      title={t("termos.title", "Termos de Uso")}
      icon={FileText}
      intro={<p>{t("termos.intro", "Bem-vindo ao website da Calriz. Ao acessar ou usar nosso site e serviços, você concorda com estes Termos de Uso. Por favor, leia-os atentamente.")}</p>}
      sections={sections}
      updated={t("termos.last_update", "Última atualização: Janeiro de 2026")}
    />
  );
}
